// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ChapterViewModal — Teal/Gold branded chapter detail modal */

.chapter-view-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  animation: fadeIn 0.2s ease;
}

.chapter-view-modal {
  background: #fff;
  border-radius: 16px;
  width: 90vw;
  max-width: 820px;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  animation: slideUp 0.25s ease;
  overflow: hidden;
}

/* Header */
.chapter-modal-header {
  background: linear-gradient(135deg, #1A5F7A 0%, #103A49 100%);
  padding: 24px 28px 20px;
  color: #fff;
  position: relative;
}

.chapter-modal-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #D4AC0D, #FFDB66, #D4AC0D);
}

.chapter-modal-title {
  font-family: 'Playfair Display', serif;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 8px;
  line-height: 1.3;
}

.chapter-modal-meta-bar {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: center;
}

.chapter-modal-meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.8rem;
  opacity: 0.9;
}

.chapter-modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: #fff;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}

.chapter-modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

.chapter-modal-status {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.chapter-modal-status--completed,
.chapter-modal-status--published {
  background: rgba(20, 97, 82, 0.3);
  color: #a7f3d0;
}

.chapter-modal-status--draft {
  background: rgba(212, 172, 13, 0.3);
  color: #FFDB66;
}

.chapter-modal-status--processing {
  background: rgba(26, 95, 122, 0.3);
  color: #93c5fd;
}

/* Body */
.chapter-modal-body {
  padding: 24px 28px;
  overflow-y: auto;
  flex: 1;
}

/* Creation Steps Timeline */
.creation-steps-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  color: #1A5F7A;
  margin: 0 0 16px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.creation-steps-timeline {
  position: relative;
  padding-left: 32px;
}

.creation-steps-timeline::before {
  content: '';
  position: absolute;
  left: 11px;
  top: 4px;
  bottom: 4px;
  width: 2px;
  background: linear-gradient(to bottom, #1A5F7A, #D4AC0D);
  border-radius: 1px;
}

.creation-step {
  position: relative;
  padding-bottom: 16px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.creation-step:last-child {
  padding-bottom: 0;
}

.creation-step-dot {
  position: absolute;
  left: -32px;
  top: 2px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #fff;
  border: 2px solid #1A5F7A;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  font-size: 0.6rem;
  font-weight: 700;
  color: #1A5F7A;
}

.creation-step-dot--filled {
  background: #1A5F7A;
  color: #fff;
}

.creation-step-dot--gold {
  border-color: #D4AC0D;
  background: #D4AC0D;
  color: #fff;
}

.creation-step-label {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6C757D;
  min-width: 120px;
}

.creation-step-value {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.875rem;
  color: #212529;
  font-weight: 500;
  text-transform: capitalize;
}

.creation-step-value--empty {
  color: #ADB5BD;
  font-style: italic;
}

.creation-step-detail {
  font-size: 0.75rem;
  color: #6C757D;
  margin-top: 2px;
}

/* Content Preview */
.chapter-content-section {
  margin-top: 24px;
}

.chapter-content-label {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  color: #1A5F7A;
  margin: 0 0 12px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.chapter-content-preview {
  background: #F9FAFB;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  padding: 20px;
  max-height: 240px;
  overflow-y: auto;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.9rem;
  line-height: 1.7;
  color: #374151;
  white-space: pre-wrap;
}

/* AI Transformation row */
.chapter-ai-row {
  display: flex;
  gap: 24px;
  margin-top: 16px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #E6F2F5 0%, #FFF9E6 100%);
  border-radius: 10px;
}

.chapter-ai-stat {
  display: flex;
  flex-direction: column;
}

.chapter-ai-stat-label {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.7rem;
  font-weight: 600;
  color: #6C757D;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.chapter-ai-stat-value {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 1.1rem;
  font-weight: 700;
  color: #1A5F7A;
}

/* Footer */
.chapter-modal-footer {
  padding: 16px 28px;
  border-top: 1px solid #E5E7EB;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

/* Animations */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/components/content/ChapterViewModal.css"],"names":[],"mappings":"AAAA,8DAA8D;;AAE9D;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iDAAiD;EACjD,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,6DAA6D;EAC7D,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;AAC/D;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,gBAAgB;EAChB,OAAO;AACT;;AAEA,4BAA4B;AAC5B;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,UAAU;EACV,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C","sourcesContent":["/* ChapterViewModal — Teal/Gold branded chapter detail modal */\n\n.chapter-view-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1300;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(4px);\n  animation: fadeIn 0.2s ease;\n}\n\n.chapter-view-modal {\n  background: #fff;\n  border-radius: 16px;\n  width: 90vw;\n  max-width: 820px;\n  max-height: 88vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  animation: slideUp 0.25s ease;\n  overflow: hidden;\n}\n\n/* Header */\n.chapter-modal-header {\n  background: linear-gradient(135deg, #1A5F7A 0%, #103A49 100%);\n  padding: 24px 28px 20px;\n  color: #fff;\n  position: relative;\n}\n\n.chapter-modal-header::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #D4AC0D, #FFDB66, #D4AC0D);\n}\n\n.chapter-modal-title {\n  font-family: 'Playfair Display', serif;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0 0 8px;\n  line-height: 1.3;\n}\n\n.chapter-modal-meta-bar {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.chapter-modal-meta-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-family: 'Montserrat', sans-serif;\n  font-size: 0.8rem;\n  opacity: 0.9;\n}\n\n.chapter-modal-close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: rgba(255, 255, 255, 0.15);\n  border: none;\n  color: #fff;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s;\n}\n\n.chapter-modal-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.chapter-modal-status {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.chapter-modal-status--completed,\n.chapter-modal-status--published {\n  background: rgba(20, 97, 82, 0.3);\n  color: #a7f3d0;\n}\n\n.chapter-modal-status--draft {\n  background: rgba(212, 172, 13, 0.3);\n  color: #FFDB66;\n}\n\n.chapter-modal-status--processing {\n  background: rgba(26, 95, 122, 0.3);\n  color: #93c5fd;\n}\n\n/* Body */\n.chapter-modal-body {\n  padding: 24px 28px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n/* Creation Steps Timeline */\n.creation-steps-title {\n  font-family: 'Montserrat', sans-serif;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #1A5F7A;\n  margin: 0 0 16px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.creation-steps-timeline {\n  position: relative;\n  padding-left: 32px;\n}\n\n.creation-steps-timeline::before {\n  content: '';\n  position: absolute;\n  left: 11px;\n  top: 4px;\n  bottom: 4px;\n  width: 2px;\n  background: linear-gradient(to bottom, #1A5F7A, #D4AC0D);\n  border-radius: 1px;\n}\n\n.creation-step {\n  position: relative;\n  padding-bottom: 16px;\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.creation-step:last-child {\n  padding-bottom: 0;\n}\n\n.creation-step-dot {\n  position: absolute;\n  left: -32px;\n  top: 2px;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #fff;\n  border: 2px solid #1A5F7A;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n  font-size: 0.6rem;\n  font-weight: 700;\n  color: #1A5F7A;\n}\n\n.creation-step-dot--filled {\n  background: #1A5F7A;\n  color: #fff;\n}\n\n.creation-step-dot--gold {\n  border-color: #D4AC0D;\n  background: #D4AC0D;\n  color: #fff;\n}\n\n.creation-step-label {\n  font-family: 'Montserrat', sans-serif;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #6C757D;\n  min-width: 120px;\n}\n\n.creation-step-value {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 0.875rem;\n  color: #212529;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.creation-step-value--empty {\n  color: #ADB5BD;\n  font-style: italic;\n}\n\n.creation-step-detail {\n  font-size: 0.75rem;\n  color: #6C757D;\n  margin-top: 2px;\n}\n\n/* Content Preview */\n.chapter-content-section {\n  margin-top: 24px;\n}\n\n.chapter-content-label {\n  font-family: 'Montserrat', sans-serif;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #1A5F7A;\n  margin: 0 0 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.chapter-content-preview {\n  background: #F9FAFB;\n  border: 1px solid #E5E7EB;\n  border-radius: 12px;\n  padding: 20px;\n  max-height: 240px;\n  overflow-y: auto;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 0.9rem;\n  line-height: 1.7;\n  color: #374151;\n  white-space: pre-wrap;\n}\n\n/* AI Transformation row */\n.chapter-ai-row {\n  display: flex;\n  gap: 24px;\n  margin-top: 16px;\n  padding: 12px 16px;\n  background: linear-gradient(135deg, #E6F2F5 0%, #FFF9E6 100%);\n  border-radius: 10px;\n}\n\n.chapter-ai-stat {\n  display: flex;\n  flex-direction: column;\n}\n\n.chapter-ai-stat-label {\n  font-family: 'Montserrat', sans-serif;\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #6C757D;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.chapter-ai-stat-value {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #1A5F7A;\n}\n\n/* Footer */\n.chapter-modal-footer {\n  padding: 16px 28px;\n  border-top: 1px solid #E5E7EB;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideUp {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
